import React from 'react';
import ListLoaderLayout from 'src/components/10-atoms/loaders/ListLoaderLayout';
import { PRESSABLE_SIZE } from 'src/components/10-atoms/pressables/constants';
const TopicsLoader = ({ ...listLoaderLayoutProps }) => {
    return (React.createElement(ListLoaderLayout, { loaderItemHeight: PRESSABLE_SIZE, ...listLoaderLayoutProps }));
};
export default TopicsLoader;
